import Tr from "../Utils/Translations/Translations";
import { getBaseUrl } from "./Env";

interface APIItemPending {
  url: string;
  parameters: any;
  disableTimeout: boolean;
}

const GENERIC_ERROR: string = Tr.Translate("system", "generic_api_error");
const API_PIPELINE: any = {};
(window as any)["API_LOGS"] = [];

const getAPIQueueKey = (request: APIItemPending) => {
  return (
    (request.parameters.method ?? "GET") +
    ":" +
    request.url +
    ":" +
    (request.parameters.body ?? "")
  ).toLocaleLowerCase();
};

const getTimeout = () => {
  let devTimeout = localStorage.getItem("dev-api-timeout");
  if (devTimeout) {
    return +devTimeout;
  }

  return 30000;
};

const FetchWithTimeout = async (
  url: string,
  options: any,
  disableTimeout: boolean
) => {
  const { timeout = getTimeout() } = options;

  let finalUrl = getBaseUrl() + url;

  // normal fecth call
  if (disableTimeout) {
    try {
      //const response = await fetch(url, options);
      const response = await fetch(finalUrl, options);
      return response;
    } catch (e) {
      return {
        statusText: GENERIC_ERROR,
        status: 500,
        json: () => {
          return null;
        },
      };
    }
  }
  // timed out fecth call
  else {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(finalUrl, {
        ...options,
        signal: controller.signal,
      });
      clearTimeout(id);
      return response;
    } catch (e) {
      clearTimeout(id);
      return {
        statusText: GENERIC_ERROR,
        status: 500,
        json: () => {
          return null;
        },
      };
    }
  }
};

const FetchPipeline = async (
  url: string,
  parameters: any,
  disableTimeout: boolean
) => {
  let newItem: APIItemPending = {
    url,
    parameters,
    disableTimeout,
  };

  let apiKDescriptor = getAPIQueueKey(newItem);

  if (API_PIPELINE[apiKDescriptor]) {
    return null;
  }

  API_PIPELINE[apiKDescriptor] = newItem;

  await new Promise((r) => setTimeout(r, 500));

  let result = await FetchWithTimeout(
    newItem.url,
    newItem.parameters,
    newItem.disableTimeout
  );

  delete API_PIPELINE[apiKDescriptor];

  return result;
};

const AjaxPipeline = {
  FetchPipeline,
};

export default AjaxPipeline;
